
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "../../components/ui/dialog";

export default function Modal({ trigger, title, description, children }) {
  return (
    
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent  className='bg-white'
       onInteractOutside={(e) => e.preventDefault()}
       onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader  className="border-b pb-5">
          {title && <DialogTitle>{title}</DialogTitle>}
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
